import { computed } from 'mobx';
import { ICalendarStrings } from 'office-ui-fabric-react/lib/Calendar';
import calendarStrings from 'owa-strings/owa-calendar-strings';
import commonString from 'owa-strings/owa-common-strings';
import dateTimeStrings from 'owa-strings/owa-datetime-strings';

export default () => computedCalendarStrings.get();

const computedCalendarStrings = computed(
    (): ICalendarStrings => ({
        months: [
            dateTimeStrings.calendarMonth_January,
            dateTimeStrings.calendarMonth_February,
            dateTimeStrings.calendarMonth_March,
            dateTimeStrings.calendarMonth_April,
            dateTimeStrings.calendarMonth_May,
            dateTimeStrings.calendarMonth_June,
            dateTimeStrings.calendarMonth_July,
            dateTimeStrings.calendarMonth_August,
            dateTimeStrings.calendarMonth_September,
            dateTimeStrings.calendarMonth_October,
            dateTimeStrings.calendarMonth_November,
            dateTimeStrings.calendarMonth_December,
        ],
        shortMonths: [
            commonString.januaryAbbreviatedLowercase,
            commonString.februaryAbbreviatedLowercase,
            commonString.marchAbbreviatedLowercase,
            commonString.aprilAbbreviatedLowercase,
            commonString.mayAbbreviatedLowercase,
            commonString.juneAbbreviatedLowercase,
            commonString.julyAbbreviatedLowercase,
            commonString.augustAbbreviatedLowercase,
            commonString.septemberAbbreviatedLowercase,
            commonString.octoberAbbreviatedLowercase,
            commonString.novemberAbbreviatedLowercase,
            commonString.decemberAbbreviatedLowercase,
        ],
        days: [
            dateTimeStrings.calendarDayOfWeek_Sunday,
            dateTimeStrings.calendarDayOfWeek_Monday,
            dateTimeStrings.calendarDayOfWeek_Tuesday,
            dateTimeStrings.calendarDayOfWeek_Wednesday,
            dateTimeStrings.calendarDayOfWeek_Thursday,
            dateTimeStrings.calendarDayOfWeek_Friday,
            dateTimeStrings.calendarDayOfWeek_Saturday,
        ],
        shortDays: [
            dateTimeStrings.calendarDayOfWeek_Su,
            dateTimeStrings.calendarDayOfWeek_Mo,
            dateTimeStrings.calendarDayOfWeek_Tu,
            dateTimeStrings.calendarDayOfWeek_We,
            dateTimeStrings.calendarDayOfWeek_Th,
            dateTimeStrings.calendarDayOfWeek_Fr,
            dateTimeStrings.calendarDayOfWeek_Sa,
        ],
        goToToday: calendarStrings.goToTodayStringLowerCaseText,
        prevMonthAriaLabel: calendarStrings.goToPreviousMonthStringLowerCaseText,
        nextMonthAriaLabel: calendarStrings.goToNextMonthStringLowerCaseText,
        prevYearAriaLabel: calendarStrings.goToPreviousYearStringLowerCaseText,
        nextYearAriaLabel: calendarStrings.goToNextYearStringLowerCaseText,
    })
);
